import { render, staticRenderFns } from "./UpdateAgent.vue?vue&type=template&id=0f7cad2b&"
import script from "./UpdateAgent.vue?vue&type=script&lang=ts&"
export * from "./UpdateAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports